import { render } from "./Section1Hero.vue?vue&type=template&id=9dd4882e&scoped=true&ts=true"
import script from "./Section1Hero.vue?vue&type=script&lang=ts"
export * from "./Section1Hero.vue?vue&type=script&lang=ts"

import "./Section1Hero.vue?vue&type=style&index=0&id=9dd4882e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd4882e"]])

export default __exports__